// Mock data for development purposes

// Mock Users
export const mockUsers = [
  {
    id: 'user_client1',
    username: 'client1',
    password: 'password', // In a real app, passwords would never be stored like this
    role: 'client',
    name: 'John Doe',
    email: 'john@example.com',
    phone: '+27 71 234 5678',
    address: '123 Main St, Sandton, Johannesburg',
    status: 'active',
    lastActive: new Date().toISOString(),
    createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString() // 30 days ago
  },
  {
    id: 'user_client2',
    username: 'client2',
    password: 'password',
    role: 'client',
    name: 'Sarah Johnson',
    email: 'sarah@example.com',
    phone: '+27 82 345 6789',
    address: '456 Oak Ave, Rosebank, Johannesburg',
    status: 'active',
    lastActive: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), // 2 hours ago
    createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString() // 60 days ago
  },
  {
    id: 'user_client3',
    username: 'client3',
    password: 'password',
    role: 'client',
    name: 'Michael Brown',
    email: 'michael@example.com',
    phone: '+27 83 456 7890',
    address: '789 Pine Rd, Pretoria',
    status: 'inactive',
    lastActive: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(), // 15 days ago
    createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString() // 90 days ago
  },
  {
    id: 'user_client4',
    username: 'client4',
    password: 'password',
    role: 'client',
    name: 'Emily Wilson',
    email: 'emily@example.com',
    phone: '+27 84 567 8901',
    address: '321 Cedar Blvd, Hyde Park, Johannesburg',
    status: 'active',
    lastActive: new Date(Date.now() - 30 * 60 * 1000).toISOString(), // 30 minutes ago
    createdAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString() // 45 days ago
  },
  {
    id: 'user_admin1',
    username: 'admin_user',
    password: 'adminpass',
    role: 'admin',
    name: 'Admin User',
    email: 'admin@example.com',
    phone: '+27 85 678 9012',
    address: '555 Admin St, Johannesburg',
    status: 'active',
    lastActive: new Date().toISOString(),
    createdAt: new Date(Date.now() - 120 * 24 * 60 * 60 * 1000).toISOString() // 120 days ago
  }
];

// Mock Assets (Jewelry)
export const mockAssets = [
  {
    id: 'asset001',
    name: 'Diamond Necklace',
    description: 'Platinum necklace with 2 carat diamond pendant',
    type: 'necklace',
    value: 15000,
    ownerId: 'user_client1',
    status: 'normal',
    location: { lat: -26.204103, lng: 28.047304 }, // Sandton, Johannesburg
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Diamond+Necklace',
    batteryLevel: 85,
    inTransit: false,
    securityLevel: 'high'
  },
  {
    id: 'asset002',
    name: 'Ruby Earrings',
    description: 'White gold earrings with ruby gemstones',
    type: 'earrings',
    value: 8000,
    ownerId: 'user_client1',
    status: 'normal',
    location: { lat: -26.145738, lng: 28.092537 }, // Rosebank, Johannesburg
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Ruby+Earrings',
    batteryLevel: 15,
    inTransit: false,
    securityLevel: 'medium'
  },
  {
    id: 'asset003',
    name: 'Gold Watch',
    description: 'Luxury gold watch with diamond accents',
    type: 'watch',
    value: 25000,
    ownerId: 'user_client1',
    status: 'warning',
    location: { lat: -26.107567, lng: 28.056702 }, // Hyde Park, Johannesburg
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Gold+Watch',
    batteryLevel: 45,
    inTransit: false,
    securityLevel: 'high'
  },
  {
    id: 'asset004',
    name: 'Sapphire Ring',
    description: 'Platinum ring with large sapphire stone',
    type: 'ring',
    value: 12000,
    ownerId: 'user_admin1', // Admin also has some assets for demo
    status: 'normal',
    location: { lat: -25.772897, lng: 28.244026 }, // Pretoria (nearby region)
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Sapphire+Ring',
    batteryLevel: 92,
    inTransit: false,
    securityLevel: 'medium'
  },
  {
    id: 'asset005',
    name: 'Emerald Bracelet',
    description: 'White gold bracelet with emerald stones',
    type: 'bracelet',
    value: 18000,
    ownerId: 'user_client2',
    status: 'normal',
    location: { lat: -26.156734, lng: 28.003452 }, // Johannesburg
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Emerald+Bracelet',
    batteryLevel: 78,
    inTransit: false,
    securityLevel: 'high'
  },
  {
    id: 'asset006',
    name: 'Pearl Necklace',
    description: 'Elegant pearl necklace with gold clasp',
    type: 'necklace',
    value: 5000,
    ownerId: 'user_client2',
    status: 'normal',
    location: { lat: -26.145738, lng: 28.092537 }, // Rosebank, Johannesburg
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Pearl+Necklace',
    batteryLevel: 65,
    inTransit: true,
    securityLevel: 'medium',
    transitDetails: {
      origin: { lat: -26.145738, lng: 28.092537, name: 'Rosebank' },
      destination: { lat: -26.204103, lng: 28.047304, name: 'Sandton' },
      startTime: new Date(Date.now() - 30 * 60 * 1000).toISOString(), // 30 minutes ago
      estimatedArrival: new Date(Date.now() + 15 * 60 * 1000).toISOString(), // 15 minutes from now
      currentSpeed: 35 // km/h
    }
  },
  {
    id: 'asset007',
    name: 'Diamond Tiara',
    description: 'Antique diamond tiara with platinum setting',
    type: 'tiara',
    value: 75000,
    ownerId: 'user_client3',
    status: 'alert',
    location: { lat: -26.187356, lng: 28.043671 }, // Johannesburg
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Diamond+Tiara',
    batteryLevel: 32,
    inTransit: false,
    securityLevel: 'very-high'
  },
  {
    id: 'asset008',
    name: 'Gold Cufflinks',
    description: 'Solid gold cufflinks with onyx inlay',
    type: 'cufflinks',
    value: 3000,
    ownerId: 'user_client4',
    status: 'normal',
    location: { lat: -26.107567, lng: 28.056702 }, // Hyde Park, Johannesburg
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Gold+Cufflinks',
    batteryLevel: 90,
    inTransit: false,
    securityLevel: 'low'
  },
  {
    id: 'asset009',
    name: 'Platinum Watch',
    description: 'Limited edition platinum watch with chronograph',
    type: 'watch',
    value: 35000,
    ownerId: 'user_client4',
    status: 'warning',
    location: { lat: -26.116543, lng: 28.034521 }, // Moving between locations
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Platinum+Watch',
    batteryLevel: 25,
    inTransit: true,
    securityLevel: 'high',
    transitDetails: {
      origin: { lat: -26.107567, lng: 28.056702, name: 'Hyde Park' },
      destination: { lat: -26.204103, lng: 28.047304, name: 'Sandton' },
      startTime: new Date(Date.now() - 45 * 60 * 1000).toISOString(), // 45 minutes ago
      estimatedArrival: new Date(Date.now() + 30 * 60 * 1000).toISOString(), // 30 minutes from now
      currentSpeed: 28 // km/h
    }
  },
  {
    id: 'asset010',
    name: 'Diamond Earrings',
    description: 'Solitaire diamond earrings in white gold setting',
    type: 'earrings',
    value: 9500,
    ownerId: 'user_client3',
    status: 'panic',
    location: { lat: -26.167890, lng: 28.075432 }, // Johannesburg
    lastUpdated: new Date().toISOString(),
    imageUrl: 'https://via.placeholder.com/150?text=Diamond+Earrings',
    batteryLevel: 54,
    inTransit: true,
    securityLevel: 'high',
    transitDetails: {
      origin: { lat: -26.187356, lng: 28.043671, name: 'Johannesburg CBD' },
      destination: { lat: -26.107567, lng: 28.056702, name: 'Hyde Park' },
      startTime: new Date(Date.now() - 20 * 60 * 1000).toISOString(), // 20 minutes ago
      estimatedArrival: new Date(Date.now() + 25 * 60 * 1000).toISOString(), // 25 minutes from now
      currentSpeed: 0 // km/h - stopped (potential issue)
    }
  }
];

// Mock Geofences
export const mockGeofences = [
  {
    id: 'geofence001',
    name: 'Home',
    assetId: 'asset001',
    center: { lat: -26.204103, lng: 28.047304 },
    radius: 500, // meters
    active: true
  },
  {
    id: 'geofence002',
    name: 'Office',
    assetId: 'asset002',
    center: { lat: -26.145738, lng: 28.092537 },
    radius: 300, // meters
    active: true
  }
];

// Mock Alerts
export const mockAlerts = [
  {
    id: 'alert001',
    type: 'geofence_exit',
    assetId: 'asset003',
    userId: 'user_client1',
    timestamp: new Date(Date.now() - 3600000).toISOString(), // 1 hour ago
    status: 'active',
    severity: 'warning',
    message: 'Asset left designated safe area',
    location: { lat: -26.107567, lng: 28.056702 },
    acknowledged: false,
    assignedTo: null
  },
  {
    id: 'alert002',
    type: 'low_battery',
    assetId: 'asset002',
    userId: 'user_client1',
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    status: 'resolved',
    severity: 'info',
    message: 'Tracker battery below 20%',
    location: { lat: -26.145738, lng: 28.092537 },
    acknowledged: true,
    assignedTo: 'user_admin1',
    resolvedAt: new Date(Date.now() - 5400000).toISOString(), // 1.5 hours ago
    resolution: 'Battery replaced'
  },
  {
    id: 'alert003',
    type: 'PANIC',
    assetId: 'asset001',
    userId: 'user_client1',
    timestamp: new Date(Date.now() - 900000).toISOString(), // 15 minutes ago
    status: 'active',
    severity: 'critical',
    message: 'Panic button activated',
    location: { lat: -26.204103, lng: 28.047304 },
    acknowledged: true,
    assignedTo: 'user_admin1',
    notes: 'Security team dispatched'
  },
  {
    id: 'alert004',
    type: 'unusual_movement',
    assetId: 'asset005',
    userId: 'user_client2',
    timestamp: new Date(Date.now() - 1800000).toISOString(), // 30 minutes ago
    status: 'active',
    severity: 'warning',
    message: 'Unusual movement pattern detected',
    location: { lat: -26.156734, lng: 28.003452 },
    acknowledged: false,
    assignedTo: null
  },
  {
    id: 'alert005',
    type: 'PANIC',
    assetId: 'asset010',
    userId: 'user_client3',
    timestamp: new Date(Date.now() - 600000).toISOString(), // 10 minutes ago
    status: 'active',
    severity: 'critical',
    message: 'Panic button activated during transit',
    location: { lat: -26.167890, lng: 28.075432 },
    acknowledged: false,
    assignedTo: null
  },
  {
    id: 'alert006',
    type: 'speed_alert',
    assetId: 'asset006',
    userId: 'user_client2',
    timestamp: new Date(Date.now() - 1200000).toISOString(), // 20 minutes ago
    status: 'active',
    severity: 'warning',
    message: 'Asset moving faster than expected',
    location: { lat: -26.145738, lng: 28.092537 },
    acknowledged: false,
    assignedTo: null
  },
  {
    id: 'alert007',
    type: 'tamper_detected',
    assetId: 'asset007',
    userId: 'user_client3',
    timestamp: new Date(Date.now() - 3000000).toISOString(), // 50 minutes ago
    status: 'active',
    severity: 'critical',
    message: 'Possible tampering with tracking device',
    location: { lat: -26.187356, lng: 28.043671 },
    acknowledged: true,
    assignedTo: 'user_admin1',
    notes: 'Investigating possible false alarm'
  },
  {
    id: 'alert008',
    type: 'stopped_movement',
    assetId: 'asset009',
    userId: 'user_client4',
    timestamp: new Date(Date.now() - 300000).toISOString(), // 5 minutes ago
    status: 'active',
    severity: 'warning',
    message: 'Asset stopped moving during transit',
    location: { lat: -26.116543, lng: 28.034521 },
    acknowledged: false,
    assignedTo: null
  }
];

// Mock Statistics
export const mockStatistics = {
  totalAssets: 10,
  totalUsers: 5,
  activeAlerts: 6,
  resolvedAlerts: 1,
  assetsInTransit: 3,
  totalValue: 206500,
  alertsByType: {
    'PANIC': 2,
    'geofence_exit': 1,
    'low_battery': 1,
    'unusual_movement': 1,
    'speed_alert': 1,
    'tamper_detected': 1,
    'stopped_movement': 1
  },
  alertsBySeverity: {
    'critical': 3,
    'warning': 4,
    'info': 1
  },
  assetsByStatus: {
    'normal': 6,
    'warning': 2,
    'alert': 1,
    'panic': 1
  },
  assetsByType: {
    'necklace': 2,
    'earrings': 2,
    'watch': 2,
    'ring': 1,
    'bracelet': 1,
    'tiara': 1,
    'cufflinks': 1
  },
  // Daily alert counts for the past week
  alertsOverTime: [
    { date: '2023-05-05', count: 2 },
    { date: '2023-05-06', count: 1 },
    { date: '2023-05-07', count: 0 },
    { date: '2023-05-08', count: 3 },
    { date: '2023-05-09', count: 2 },
    { date: '2023-05-10', count: 1 },
    { date: '2023-05-11', count: 4 },
    { date: '2023-05-12', count: 8 }
  ],
  // Monthly alert counts
  alertsByMonth: [
    { month: 'Jan', count: 12 },
    { month: 'Feb', count: 8 },
    { month: 'Mar', count: 15 },
    { month: 'Apr', count: 10 },
    { month: 'May', count: 18 },
    { month: 'Jun', count: 0 },
    { month: 'Jul', count: 0 },
    { month: 'Aug', count: 0 },
    { month: 'Sep', count: 0 },
    { month: 'Oct', count: 0 },
    { month: 'Nov', count: 0 },
    { month: 'Dec', count: 0 }
  ],
  // Asset value by type
  assetValueByType: [
    { type: 'necklace', value: 45000 },
    { type: 'earrings', value: 32000 },
    { type: 'watch', value: 55000 },
    { type: 'ring', value: 27000 },
    { type: 'bracelet', value: 18000 },
    { type: 'tiara', value: 22000 },
    { type: 'cufflinks', value: 7500 }
  ],
  userActivity: [
    { userId: 'user_client1', alertCount: 3, assetsCount: 3, lastActive: new Date().toISOString() },
    { userId: 'user_client2', alertCount: 2, assetsCount: 2, lastActive: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString() },
    { userId: 'user_client3', alertCount: 2, assetsCount: 2, lastActive: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString() },
    { userId: 'user_client4', alertCount: 1, assetsCount: 2, lastActive: new Date(Date.now() - 30 * 60 * 1000).toISOString() },
    { userId: 'user_admin1', alertCount: 0, assetsCount: 1, lastActive: new Date().toISOString() }
  ],
  locationHotspots: [
    { location: 'Sandton', count: 3, coordinates: { lat: -26.204103, lng: 28.047304 } },
    { location: 'Rosebank', count: 2, coordinates: { lat: -26.145738, lng: 28.092537 } },
    { location: 'Hyde Park', count: 2, coordinates: { lat: -26.107567, lng: 28.056702 } },
    { location: 'Pretoria', count: 1, coordinates: { lat: -25.772897, lng: 28.244026 } },
    { location: 'Johannesburg CBD', count: 2, coordinates: { lat: -26.187356, lng: 28.043671 } }
  ]
};
